import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

export default function OtpVerificationPage() {
    const [code, setCode] = useState('');
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [loading, setLoading] = useState(false);
    const timerRef = useRef(null);
    const { handleLogin } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const { email, password, require_2fa_setup, qr_code } = location.state || {};
    function getDefaultDashboardByPermission(permissions = []) {
        if (permissions.includes("dashboard-main")) return "/dashboard";
        if (permissions.includes("dashboard-sales")) return "/sales-dashboard";
        if (permissions.includes("dashboard-account")) return "/account-dashboard";
        if (permissions.includes("dashboard-operation")) return "/operation-dashboard"; // optional
        return null;
    }
    useEffect(() => {
        if (!email || !password) {
            navigate('/login');
            return;
        }
        startCountdown();
        return () => clearInterval(timerRef.current);
    }, []);

    const startCountdown = () => {
        setTimer(60);
        setCanResend(false);
        timerRef.current = setInterval(() => {
            setTimer(prev => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    setCanResend(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const verifyCode = async () => {
        setLoading(true);
        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        try {
            const res = await axios.post(`${backendUrl}/api/login`, {
                email,
                password,
                two_factor_code: code,
            }, {
                withCredentials: true,
                headers: { 'Tenant-Origin': window.location.origin },
            });

            const result = res.data;
            localStorage.setItem('user-info', JSON.stringify(result));
            localStorage.setItem('user-origin', window.location.origin);
            handleLogin(result);
            Swal.fire({
                toast: true,
                icon: 'success',
                title: 'Login Successful!',
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false,
            });
            // navigate('/');
            const defaultRoute = getDefaultDashboardByPermission(result.permissions || []);
            if (defaultRoute) {
                navigate(defaultRoute);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Access Denied',
                    text: 'You do not have permission to access any dashboard.',
                });
            }

        } catch (err) {
            Swal.fire({
                toast: true,
                icon: 'error',
                title: 'Invalid OTP. Please try again.',
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false,
            });
        } finally {
            setLoading(false);
        }
    };

    const resendOtp = async () => {
        setLoading(true);
        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        try {
            await axios.post(`${backendUrl}/api/login`, {
                email,
                password
            }, {
                withCredentials: true,
                headers: { 'Tenant-Origin': window.location.origin },
            });

            startCountdown();
            Swal.fire({
                toast: true,
                icon: 'info',
                title: 'OTP resent to your email.',
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false,
            });
        } catch {
            Swal.fire({
                toast: true,
                icon: 'error',
                title: 'Failed to resend OTP.',
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div>
                <div>
                    <div className="back">
                        <div className='container2'>
                            <div className="content">
                                <div>
                                    <h4 className="form-tilte3 text-center">Two-Factor Authentication</h4>
                                    
                                    {require_2fa_setup ? (
                                        <>
                                            <p className="text-center text-muted mb-3 font-size-12">
                                                <strong>Setup Required:</strong> Please scan this QR code with your<br />
                                                Authenticator App (Google Authenticator, Authy, etc.)<br />
                                                and enter the 6-digit code below to link your device.
                                            </p>
                                            <div className="d-flex justify-content-center mb-3">
                                                <img src={qr_code} alt="QR Code" style={{ width: '200px', height: '200px' }} />
                                            </div>
                                        </>
                                    ) : (
                                        <p className="text-center text-muted mb-4 font-size-12">
                                            Please open your Authenticator App (Google Authenticator, Authy, etc.)<br />
                                            and enter the 6-digit code below to<br />
                                            complete the login process.
                                        </p>
                                    )}
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control form-control-lg text-center font-size-11"
                                            placeholder="Authentication Code"
                                            value={code}
                                            onChange={(e) => setCode(e.target.value)}
                                        />
                                    </div><br />
                                    <div className="d-grid mb-3">
                                        <button
                                            className="btn btn-primary waves-effect waves-light font-size-12"
                                            onClick={verifyCode}
                                            disabled={loading}
                                        >
                                            {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                                            Verify
                                        </button>
                                    </div>




                                </div>
                            </div>
                        </div>
                    </div>
                </div></div></div>

    );
}
